// eslint-disable-next-line import/prefer-default-export
export const faviconMap = {
  bettermeedu: 'https://download-pa-s3.thethinkacademy.com/static-pa/project/thinkacademy-website-web/prod/favicon/betterme-favicon.ico',
  default: 'https://download-pa-s3.thethinkacademy.com/static-pa/project/thinkacademy-website-web/prod/favicon/thethinkacademy-favicon.ico',
}
